// Avoid `console` errors in browsers that lack a console.
(function() {
	var method;
	var noop = function () {};
	var methods = [
		'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
		'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
		'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
		'timeStamp', 'trace', 'warn'
	];
	var length = methods.length;
	var console = (window.console = window.console || {});

	while (length--) {
		method = methods[length];

		// Only stub undefined methods.
		if (!console[method]) {
			console[method] = noop;
		}
	}
}());

jQuery(document).ready(function($) {
	// $() will work as an alias for jQuery() inside of this function


	// Navigation Dropdowns

	var menuCollapsePoint = 998; // width in pixels

	// set main navigation to toggle dropdowns when collapsed
	// this only happens on initial page load and does not change on resize
	if($(window).width() < menuCollapsePoint) {
		$('.nav-wrapper .dropdown > a').attr('data-toggle', 'dropdown');
	} else {
		// dropdown animated hover icon
		$('.navbar-default .dropdown-menu a').hover(function() {
			$(this).velocity({
				paddingLeft: 40,
				backgroundPositionX: 10
			}, 400);
			}, function() {
			$(this).velocity({
				paddingLeft: 15,
				backgroundPositionX: -23
			}, 300);
		});
	}


	// Slider

	// size the main slider and adjust the bottom margin so that the main content covers about 1/5
	// of the bottom of screen on larger screen sizes
	function sizeSlider() {
		if($('.carousel-inner').children().length < 1) {
			$('.carousel-inner').html('<div class="item" style="background-image: url(\'http://placehold.it/1440x900\');"><img class="img-responsive" src="http://placehold.it/1440x900" /></div>');
		}
		// minimum height of page content to show (px)
		var mainContentMinShow = 150;
		var slideWidth = 1440;
		var slideHeight = 900;
		var ratio = slideWidth/slideHeight;
		var windowWidth =  $(window).width();
		var windowHeight =  $(window).height();
		var newSlideHeight = windowWidth/ratio;

		$('.carousel .item').css('height', newSlideHeight);
		if(newSlideHeight >= (windowHeight - mainContentMinShow)) {
			// have content take up 1/3 of the screen
			var marginBottom = (newSlideHeight - windowHeight) + windowHeight/5;
			$('.carousel').css('margin-bottom', '-'+marginBottom+'px');
			$('.carousel-indicators').css('bottom', marginBottom+'px');
		} else {
			$('.carousel').css('margin-bottom', '');
			$('.carousel-indicators').css('bottom', '');
		}
	}

	sizeSlider();
	$(window).on('resize', sizeSlider);


	// Accordion

	// accordion event handler
	function toggleAccordionElement(event) {
		var toggleTarget = $($(this).attr('href'));
		var openedIcon = 'fa-caret-down';
		var closedIcon = 'fa-caret-right';
		var openedClass = 'opened';
		var toggleElem = $(this).children('.atoggle');

		event.preventDefault();

		if (toggleElem.hasClass(openedClass)) {
			toggleElem.removeClass(openedClass + ' ' + openedIcon).addClass(closedIcon);
			toggleTarget.velocity('slideUp');
		} else {
			toggleElem.removeClass(closedIcon).addClass(openedClass + ' ' + openedIcon);
			toggleTarget.velocity('slideDown');
		}
	}
	// initialize accordion
	$('.pcontent').hide().first().show();
	$('.atoggle').first().addClass('opened').removeClass('fa-caret-right').addClass('fa-caret-down');
	// setup accordion toggle event
	$('.aopener').click(toggleAccordionElement);


	// Rooms

	// handles the room selection event for large screens
	function roomSelectAction() {
		var roomId = $(this).find('a').data('room-id');

		if($(this).hasClass('active')) {
			return;
		}

		$(this).parent().find('.active').each(function() {
			$(this).removeClass('active').find('.dropdown-menu').velocity('slideUp');
		});
		$(this).addClass('active').find('.dropdown-menu').velocity('slideDown');
		$('.room-details-list > .room-item').hide();
		$('#room-id-' + roomId).show();
		// update small view navigation, not abolutely necessary but the two navigation methods will
		// get out of sync if this is not done
		$('.room-title-top').each(function() { $(this).removeClass('active'); });
		$('.room-title-top[data-room-id="' + roomId + '"]').addClass('active');
	}
	$('.rooms-nav .dropdown').click(roomSelectAction);
	// small screen room event
	// open/close behaviour on smaller screens
	$('.room-details-container .room-title-top').click(function() {
		var roomId = $(this).data('room-id');

		if($(this).hasClass('active')) {
			$(this).removeClass('active');
			$('#room-id-' + roomId).velocity('slideUp');
			return;
		}
		$(this).siblings('.active').each(function() {
			$(this).removeClass('active');
			$('#room-id-' + $(this).data('room-id')).velocity('slideUp');
		});
		$(this).addClass('active');
		$('#room-id-' + roomId).velocity('slideDown');
		// update larger view navigation, not abolutely necessary but the two navigation methods will
		// get out of sync if this is not done
		$('.room-link').each(function() { $(this).parent().removeClass('active').find('.dropdown-menu').hide(); });
		$('.room-link[data-room-id="' + roomId + '"]').parent().addClass('active').find('.dropdown-menu').show();
	});


	// Tabs

	// set active bootstrap tab
	var tabHash = window.location.hash;
	if (tabHash && tabHash.length > 0 && tabHash.length <= 30) {
		var tabDiv = $('#page-tabs');
		if(tabDiv.offset()) {
			$('.tabs-wrapper ul li a[href="' + tabHash + '"]').tab('show');
			$('.tab-pane' + tabHash).addClass('fade in');

			$('html,body').delay(500).animate({scrollTop: tabDiv.offset().top}, 1500);
		}
	} else {
		$('.tabs-wrapper ul li:first a').tab('show');
		$('.tab-pane:first').addClass('fade in');
	}
});

jQuery(window).load(function() {
//	jQuery("#preloadspace").hide();
//	jQuery("#main_slider").show();
});
